import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React from "react";
import LoadingSpinner from "./loading";

// Styled DataGrid with custom styles
export const StyledDataGrid = styled(DataGrid)({
  border: "none",
  overflowX: "auto",
  // height: "600px",
  "& .MuiDataGrid-columnHeaders": {
    background: "#fff",
    backgroundColor: "#fff",
    color: "#404040",
    fontSize: "16px",
    borderBottom: "none",
  },
  "& .MuiDataGrid-row": {
    backgroundColor: "#fff",
    color: "#3e4954",
    fontSize: "14px",
    borderBottom: "none",
  },
  "& .MuiDataGrid-cell": {
    border: "none",
  },
  "& .MuiTablePagination-root": {
    backgroundColor: "#fff",
    display: "none",
    padding: 0,
    margin: 0,
  },
  "& .MuiDataGrid-footerContainer": {
    backgroundColor: "#fff",
    display: "none",
  },
});
const CustomDataGrid = ({
  rows,
  columns,
  pageSize = 5,
  rowsPerPageOptions = [5, 10, 20],
  checkboxSelection = false,
  disableSelectionOnClick = false,
  onRowClick,
  onSelectionModelChange,
  loading = false,

  ...otherProps
}) => {
  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        position: "relative",
      }}
    >
      <StyledDataGrid
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={rowsPerPageOptions}
        checkboxSelection={checkboxSelection}
        disableSelectionOnClick={disableSelectionOnClick}
        onRowClick={onRowClick}
        onSelectionModelChange={onSelectionModelChange}
        loading={loading}
        {...otherProps}
      />
      {loading && <LoadingSpinner/>}
    </div>
  );
};
CustomDataGrid.propTypes = {
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  checkboxSelection: PropTypes.bool,
  disableSelectionOnClick: PropTypes.bool,
  onRowClick: PropTypes.func,
  onSelectionModelChange: PropTypes.func,
  loading: PropTypes.bool,
  autoHeight: PropTypes.bool,
};

export default CustomDataGrid;
